import api from "./client";

export const getSiteReport = async (siteId: number | string, date: string) => {
  const res = await api.get(`/reports/site/${siteId}`, { params: { date } });
  return res.data;
};

export const regenerateReport = async (siteId: number | string, date: string) => {
  const payload = { site_id: Number(siteId), date, report_type: "daily" };
  const res = await api.post("/reports/admin/regenerate", payload);
  return res.data;
};

export const getTrackerSiteReport = async (siteId: number | string, date: string) => {
  const res = await api.get(`/reports/tracker/site/${siteId}`, { params: { date } });
  return res.data;
};

export const regenerateTrackerReport = async (siteId: number | string, date: string) => {
  const payload = { site_id: Number(siteId), date, report_type: "tracker_daily" };
  const res = await api.post("/reports/tracker/admin/regenerate", payload);
  return res.data;
};
